import { useQuery } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export interface ParagraphGenerationDto {
  jobId: string;
  slug: string;
  status: string;
  costCredits: number;
  errorMessage?: string | null;
  createdAt: string;
  completedAt?: string | null;
  result?: unknown;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export function useParagraphGenerations(
  paragraphId: string | null | undefined,
) {
  const { getToken } = useAuth();
  return useQuery<ParagraphGenerationDto[]>({
    enabled: !!paragraphId,
    queryKey: ['paragraph-generations', paragraphId],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const response = await client
        .get(`api/v2/paragraphs/${paragraphId}/generations`)
        .json<ApiResponse<ParagraphGenerationDto[]>>();
      return response.data ?? [];
    },
    refetchInterval: (query) => {
      // Poll while any row is still processing.
      const data = query.state.data as ParagraphGenerationDto[] | undefined;
      return data?.some(
        (row) => row.status === 'processing' || row.status === 'queued',
      )
        ? 5000
        : false;
    },
  });
}
